module.exports = __webpack_public_path__ + "static/media/14.06425b83.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/14.png
// module id = 1054
// module chunks = 0